export default function urlParam(param) {
  const urlParams = new URLSearchParams(location.search.substring(1));

  return urlParams.get(param);
}
